import r, { css as l } from "styled-components";
import { breakpoints as a } from "./atoms-v2125.js";
import { INPUT_EXPRESSIVE_HEIGHT as e, INPUT_PRODUCTIVE_HEIGHT_SMALL as p, INPUT_PRODUCTIVE_HEIGHT as s } from "./atoms-v2810.js";
import { Input as d } from "./atoms-v2777.js";
import { SkeletonRow as u } from "./atoms-v2778.js";
import { InputOutline as c } from "./atoms-v223.js";
import { getColor as g } from "./atoms-v2815.js";
const w = r(c)`
  align-items: start;
`, y = r.div`
  flex-grow: 1;
  min-width: 0;
`, T = r.input`
  ${d}

  ${({ $variant: o, theme: t }) => {
  var i, n;
  return o === "productive" ? (i = t == null ? void 0 : t.get("tokens.body.compact-productive")) == null ? void 0 : i.toJS() : (n = t == null ? void 0 : t.get("tokens.heading.03")) == null ? void 0 : n.toJS();
}}

  appearance: textfield;
  background-color: transparent;
  color: ${({ $colorTheme: o = "light", disabled: t, theme: i }) => g({ colorTheme: o, disabled: t, theme: i })};
  height: ${({ $variant: o }) => o === "expressive" ? e : p}px;

  /* Offset the value to make room for the floating label. This custom prop is assigned in the
  InputContainer component. */
  padding-left: var(--padding-x);
  padding-right: var(--padding-x);
  padding-top: ${({ $variant: o }) => o === "productive" ? 18 : 5}px;
  width: 100%;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    /* 
      Chrome autofill background hack:
      WebKit animates a yellow/blue background-color on autofill.
      This forces that animation to take ~9999s, so the autofill
      paint never visibly appears. Input keeps our custom styles.
    */
    transition:
      background-color 9999s ease-out,
      color 9999s ease-out;
  }

  @media ${a.medium} {
    ${({ $variant: o, theme: t }) => {
  var i, n;
  return o === "productive" ? (i = t == null ? void 0 : t.get("tokens.body.compact-expressive")) == null ? void 0 : i.toJS() : (n = t == null ? void 0 : t.get("tokens.heading.03")) == null ? void 0 : n.toJS();
}}
    height: ${({ $variant: o }) => o === "expressive" ? e : s}px;
  }
`, f = r.div`
  --padding: ${({ $variant: o }) => o === "expressive" ? 8 : 1}px;

  column-gap: 17px;
  display: flex;
  height: fit-content;
  padding: var(--padding);
  position: relative;

  ${({ $colorTheme: o = "light", $variant: t, theme: i }) => t === "productive" && l`
      &::before {
        background-color: ${i == null ? void 0 : i.get(`ui.field.${o}.border`)};
        content: '';
        height: 50%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 1px;
        z-index: 1;
      }
    `}

  /* Resolve issue in Expressive variant where button sizes aren’t calculated correctly. */
  & button {
    min-height: calc(
      ${({ $variant: o }) => o === "expressive" ? e : p}px -
        (var(--padding) * 2)
    );
  }

  @media ${a.medium} {
    padding: ${({ $variant: o }) => o === "expressive" ? 8 : 6}px;
  }
`, S = r(u)`
  align-items: start;
  column-gap: 1px;
  display: flex;
  height: ${({ $variant: o }) => o === "expressive" ? e : p}px;
  justify-content: end;

  & button i svg {
    color: ${({ $colorTheme: o = "light", theme: t }) => t == null ? void 0 : t.get(`tokens.text.${o}.primary`)};
  }

  ${f}::before {
    background-color: ${({ $colorTheme: o = "light", theme: t }) => t == null ? void 0 : t.get(`ui.field.${o}.skeleton`)};
  }

  @media ${a.medium} {
    height: ${({ $variant: o }) => o === "expressive" ? e : s}px;
  }
`;
export {
  f as Actions,
  T as Input,
  y as InputContainer,
  w as InputOutlineStyled,
  S as SkeletonInput
};
